import { Role, AllRoles, AdminRoles } from "@/helper/roles";

const supplierRoutes = [
  {
    path: "supplier",
    meta: { translated: false, label: "global.supplier" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "dashboard",
        alias: [""],
        name: "Supplier Dashboard",
        meta: { translated: false, label: "global.dashboard", authorize: AllRoles },
        component: () => import("@/views/supplier-views/Dashboard"),
      },

      //#region Products
      {
        path: "products",
        meta: { translated: false, label: "product.products", authorize: AdminRoles },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "SupplierProducts",
            meta: { translated: false, label: "product.products", authorize: AdminRoles },
            component: () => import("@/views/supplier-views/products/List"),
          },
          {
            path: "add",
            name: "Add New Supplier Product",
            meta: { translated: false, label: "product.add_new_product", authorize: AdminRoles },
            component: () => import("@/views/supplier-views/products/Item"),
          },
          {
            path: ":id",
            name: "Edit Supplier Product",
            meta: { translated: false, label: "product.edit_product", authorize: AdminRoles },
            component: () => import("@/views/supplier-views/products/Item"),
          },
        ],
      },
      //#endregion

      //#region Buyer Firms
      {
        path: "buyer-firms",
        name: "BuyerFirms",
        meta: { translated: false, label: "firm.buyer_firms", authorize: AdminRoles },
        component: () => import("@/views/supplier-views/BuyerFirms"),
      },
      //#endregion

      //#region HappyGast
      {
        path: ":happy_gast_id",
        name: "Supplier Dashboard With HappyGast Id",
        meta: { translated: false, label: "restaurant.dashboard", authorize: AllRoles },
        component: () => import("@/views/supplier-views/Dashboard"),
      },
      //#endregion
    ],
  },
];

export default supplierRoutes;
